import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {TabListItem} from '../../styles/style.js'

class Tab extends Component {
    static propTypes = {
      activeTab: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    };
  
    onClick = () => {
      const { label, onClick } = this.props;
      onClick(label);
    }
  
    render() {
      const {
        onClick,
        props: {
          activeTab,
          label,
          severity
        },
      } = this;
      let className = ''
      if (activeTab === label) {
        className += 'active';
      }

      className += ' ' + severity
  
      return (
        <TabListItem
          className={className}
          onClick={onClick}
        >
          {label}
        </TabListItem>
      );
    }
  }
  
  export default Tab;